// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","subMenuActiveText":"#333","sideBarWidth":"190px"};